import { CDBBtn } from "cdbreact";

export const ModalModules = ({
  action,
  setPressedButton,
  formData,
  handleChange,
}) => {
  return (
    <div>
      <div className="modal-header">
        <div>
          <h3 className="modal-title" id="exampleModalLabel">
            {action === "create" ? "Crear Modulo" : "Editando Modulo"}
          </h3>
        </div>
        {action === "edit" ? (
          <CDBBtn
            size="small"
            className="p-2 btn"
            color="danger"
            outline
            onClick={() => {
              setPressedButton("delete");
            }}
          >
            <i className="fas fa-trash"></i>
            Eliminar  Modulo 
          </CDBBtn>
        ) : null}
      </div>
      <div className="modal-body">
        {action !== "create" ? (
          <div className="form-group">
            <label>Id</label>
            <input
              type="text"
              className="form-control mb-4"
              id="ModuleID"
              placeholder="Id"
              disabled
              value={formData.ModuleID}
            />
          </div>
        ) : null}
        <div className="form-group">
          <label htmlFor="ModuleName">Nombre:</label>
          <input
            type="text"
            className="form-control mb-4"
            id="ModuleName"
            placeholder="Project"
            value={formData.ModuleName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="ModuleDescription">Descripción:</label>
            <textarea
                className="form-control mb-4"
                id="ModuleDescription"
                placeholder="ModuleDescription"
                value={formData.ModuleDescription}
                onChange={handleChange}
            />
        </div>

        <div className="modal-footer justify-content-center align-items-center">
          <CDBBtn
            type="button"
            color="danger"
            outline
            onClick={() => setPressedButton("closeModal")}
          >
            Cerrar
          </CDBBtn>
          <CDBBtn
            type="submit"
            color="success"
            className="mr-auto"
            outline
            onClick={() => setPressedButton("submitModal")}
          >
            Guardar
          </CDBBtn>
        </div>
      </div>
    </div>
  );
};
